export function getCsrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta?.content || ""
}

export function setCsrfToken(token) {
  if (!token) return
  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta) meta.content = token
}

